<template>
  <div id='ask' v-bind:style='{ backgroundColor: color }'>
      <textarea 
        ref='question'
        autofocus
        v-bind:style='{ backgroundColor: color }' 
        id='question' 
        v-model='text' 
        placeholder='Stell deine Frage hier'></textarea>
    <button class='ask' v-on:click='ask'>Frage stellen</button>
  </div>
</template>
<script>
export default {
  name: 'Ask',
  data(){
    return{
      text: '',
      color: null, 
      colors: [
        '#fc5c65',
        '#fd9644',
        '#fed330',
        '#2bcbba',
        '#FF9908',
        '#FFBA00',
        '#DD5F5F',
        '#06A3CB',
        '#9EC41C',
        '#8ABDB0',
        '#fa8231',
        '#f7b731',
        '#20bf6b',
        '#0fb9b1',
        '#45aaf2',
        '#4b7bec',
        '#a55eea',
        '#778ca3',
        '#2d98da',
        '#3867d6',
        '#8854d0',
        '#4b6584'
      ]
    }
  },
  methods: {
    async ask(){
      let hash = localStorage.getItem('hash')
      let text = this.text
      let color = this.color
      fetch(`${process.env.VUE_APP_API}/ask`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          text,
          hash,
          color 
        })
      })
      this.$router.push('/')
    }
  },
  mounted(){
    this.color = this.colors[Math.floor(Math.random() * this.colors.length)]
    this.$refs.question.focus()
  }
}
</script>
<style scoped>
#ask{
  display: grid;
  grid-template-rows: 1fr 120px;
  grid-template-areas:
  "question"
  "ask";
  height: 100%;
}
.ask{
  grid-area: ask;
  text-align: center;
  line-height: 120px;
  font-size: 1.5em;
  color: #2d3436;
  font-weight: bold;
  background-color: transparent;
  border: none;
  outline: none;
}
#question{
  grid-area: question;
  padding: 20px;
  font-size: 1.5em;
  outline: none;
  border: none;
  resize: none;
  color: white;
  font-family: Verdana;
}

#question::placeholder{
  color: rgba(255,255,255, 0.5);
}

button.ask:hover{
  cursor: pointer;
}
</style>
